import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'
import { state } from '@/store/modules/auth/state'

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
